import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { Paciente } from 'src/app/homecare/paciente/paciente.model';
import { SumarioPacienteQuadroPerfilQuestaoDestaqueComponent } from '../sumario-paciente-quadro-perfil-questao-destaque/sumario-paciente-quadro-perfil-questao-destaque.component';


@Component({
  selector: 'app-links-rapidos-e-questoes-favoritas-do-paciente',
  templateUrl: './links-rapidos-e-questoes-favoritas-do-paciente.component.html',
  styleUrls: ['./links-rapidos-e-questoes-favoritas-do-paciente.component.css']
})
export class LinksRapidosEQuestoesFavoritasDoPacienteComponent implements OnInit {

  @Input() paciente: Paciente = null;

  @ViewChild('appSumarioPacienteQuadroPerfilQuestaoDestaque') appSumarioPacienteQuadroPerfilQuestaoDestaque: SumarioPacienteQuadroPerfilQuestaoDestaqueComponent;

  constructor() { }

  ngOnInit(): void {
  }

  public carregarDados(): void {
    if ( this.appSumarioPacienteQuadroPerfilQuestaoDestaque ) {
      this.appSumarioPacienteQuadroPerfilQuestaoDestaque.carregarDados();
    }
  }

}
